// extracted by mini-css-extract-plugin
export default {"body":"Page404Content_body__xvoW+"};